import { abandonUnpaidReceipt } from "../APICalls/APICalls";

/**
 * The order a guest is paying with DSQ partner points (prepits/project#4445).
 *
 * Only the receipt id is kept, in sessionStorage, so it survives a reload of
 * the partner-points page (the webview session and its token are memory-only
 * and do not). Never the token.
 */
export const PARTNER_POINTS_ORDER_KEY = "prepit-dsqpwp-order";

export const rememberPartnerPointsOrder = (receiptId: number | undefined) => {
  if (!receiptId) {
    return;
  }
  try {
    window.sessionStorage.setItem(PARTNER_POINTS_ORDER_KEY, String(receiptId));
  } catch {
    // Storage blocked: the reload case simply cannot abandon.
  }
};

/** The remembered order, forgotten in the same step so it is abandoned once. */
export const takePartnerPointsOrder = (): number | null => {
  try {
    const stored = window.sessionStorage.getItem(PARTNER_POINTS_ORDER_KEY);
    window.sessionStorage.removeItem(PARTNER_POINTS_ORDER_KEY);
    const receiptId = Number(stored);

    return stored && Number.isInteger(receiptId) && receiptId > 0
      ? receiptId
      : null;
  } catch {
    return null;
  }
};

/**
 * The guest left the partner-points page without paying: the order is
 * abandoned, so its held loyalty points and offer are released and, when the
 * guest already redeemed at DSQ, core refunds those points before cancelling
 * (prepits/prepareit-backend#765). Core refuses a paid order, so a stray call
 * after a redemption that covered the order changes nothing. Best effort:
 * on failure the loyalty hold expiry cancels the order later.
 */
export const abandonPartnerPointsOrder = async (
  receiptId: number | null | undefined
): Promise<void> => {
  if (!receiptId) {
    return;
  }
  try {
    await abandonUnpaidReceipt(receiptId);
  } catch {
    // Best effort, as the gateway abandon in useReleaseAbandonedPayment.
  }
};
